import { cva } from "class-variance-authority"

export const selectFieldVariants = cva(
  `group relative m-px inline-block w-[8.25rem] rounded text-general-primary-text font-medium-525`,
  {
    variants: {
      error: {
        true: "outline outline-1 outline-general-red focus-within:outline-none",
      },
      success: {
        true: "outline outline-1 outline-general-green focus-within:outline-none",
      },
    },
  }
)

// defining this for the sake of selectSizeKeys below
const size = {
  default: "",
  narrow: "",
}
export const selectSizeKeys = Object.keys(size)

export const selectTriggerVariants = cva(
  `inline-flex w-full items-center justify-between rounded bg-input-field-dropdown-primary p-2 pl-3 outline-none focus-within:outline-2 focus-visible:outline-2 disabled:cursor-not-allowed disabled:text-icon-general-disabled`,
  {
    variants: {
      size: {
        default: "h-10",
        narrow: "h-8 p-1 px-2 focus-within:outline-1 focus-visible:outline-1",
      },
      v2: {
        true: `bg-interaction-field outline-offset-0 transition-colors focus-within:bg-interaction-field-selected focus-within:text-icon-general-primary focus-within:outline-1 focus-within:outline-semantic-interaction-focused hover:bg-interaction-field-hovered focus-visible:bg-interaction-field-selected focus-visible:text-icon-general-primary focus-visible:outline-1 focus-visible:outline-semantic-interaction-focused group-data-[disabled=true]:bg-button-inactive`,
      },
    },
  }
)

export const selectOptionVariants = cva(
  "cursor-pointer text-general-primary-text font-medium-525",
  {
    variants: {
      size: {
        default: "p-2 pl-3",
        narrow: "h-8 p-1",
      },
      v2: {
        true: "bg-interaction-item flex items-center justify-between gap-2 border border-transparent border-t-general-neutral-02 first:border-t-transparent aria-selected:bg-interaction-item-hovered data-[kb-highlighted='true']:border-semantic-interaction-selected data-[highlighted='true']:bg-interaction-item-hovered",
        false:
          "odd:bg-input-field-dropdown-secondary even:bg-input-field-dropdown-primary data-[highlighted='true']:bg-blue-500 data-[highlighted='true']:text-general-static-white-text",
      },
      // only used in compoundVariants
      multiselect: {
        true: "",
        false: "",
      },
    },
    defaultVariants: {
      size: "default",
      v2: false,
      multiselect: false,
    },
    compoundVariants: [
      {
        multiselect: false,
        size: "narrow",
        className: "px-1.5",
      },
    ],
  }
)
